import { Injectable, EventEmitter, Inject } from "@angular/core";
import {
  KreTableFieldConfig,
  KreFormFieldConfig,
  KreTableConfig,
  clone,
} from "@kre-form/core";
import { IBusinessTable } from "./util";
import * as _ from "lodash";
import { KreToFormFieldService } from "./formFieldService";

@Injectable()
export class KreDesginToFormService {
  constructor(
    @Inject(KreToFormFieldService)
    private toFormField: KreToFormFieldService
  ) {}

  initTableStatus(tables: IBusinessTable, fields: KreFormFieldConfig[]) {
    this.initTableFields(tables);
    if (fields && fields != null && fields.length > 0) {
      fields.forEach((field: any, index: any, object: any) => {
        this.setTableStatus(tables, field);
      });
    }
  }

  initFormFieldByTables(tables: IBusinessTable, fields: KreFormFieldConfig[]) {
    if (
      tables != undefined &&
      tables != null &&
      tables.primary != undefined &&
      tables.primary != null &&
      tables.primary.tableFields != undefined &&
      tables.primary.tableFields != null
    ) {
      let tableFileds: KreTableFieldConfig[] = tables.primary.tableFields.filter(
        (item: any) => {
          return item.isButintin === true;
        }
      );
      if (tableFileds != null) {
        tableFileds.forEach((item: any) => {
          if (!this.checkKreFormFieldConfig(item.fieldCode, fields)) {
            this.addKreFormFieldConfig(item, fields);
          }
        });
      }
    }
  }

  private initTableFields(tables: IBusinessTable) {
    if (!tables) {
      return;
    }

    if (tables.primary) {
      tables.primary.tableQuote = false;
      if (tables.primary.tableFields) {
        tables.primary.tableFields.forEach((field: any) => {
          field.fieldQuote = false;
        });
      }
    }

    if (tables.child) {
      if (tables.child.single) {
        tables.child.single.forEach((table: any) => {
          table.tableQuote = false;
          if (table.tableFields) {
            table.tableFields.forEach((field: any) => {
              field.fieldQuote = false;
            });
          }
        });
      }
      if (tables.child.multiple) {
        tables.child.multiple.forEach((table: any) => {
          table.tableQuote = false;
          if (table.tableFields) {
            table.tableFields.forEach((field: any) => {
              field.fieldQuote = false;
            });
          }
        });
      }
    }
  }

  private setTableStatus(tables: IBusinessTable, field: KreFormFieldConfig) {
    if (tables) {
      if (tables.primary) {
        this.setTablePrimary(tables.primary, field);
      }

      if (tables.child) {
        if (tables.child.single) {
          this.setTableSingle(tables.child.single, field);
        }
        if (tables.child.multiple) {
          this.setTableMultiple(tables.child.multiple, field);
        }
      }
    }
  }

  private setTablePrimary(table: KreTableConfig, field: KreFormFieldConfig) {
    // if (field.tableCode === table.tableCode) {
    //   table.tableQuote = true;
    if (table.tableFields) {
      table.tableFields.forEach((item: any) => {
        if (item.fieldCode === field.key) {
          item.fieldQuote = true;
        }
      });
    }
    //}
  }

  private setTableSingle(tables: KreTableConfig[], field: KreFormFieldConfig) {
    if (tables && tables != null && tables.length > 0) {
      tables.forEach((table) => {
        // if (table.tableCode === field.tableCode) {
        //   table.tableQuote = true;
        if (table.tableFields) {
          table.tableFields.forEach((item: any) => {
            if (item.fieldCode === field.key) {
              item.fieldQuote = true;
            }
          });
        }
        //}
      });
    }
  }

  private setTableMultiple(
    tables: KreTableConfig[],
    groupField: KreFormFieldConfig
  ) {
    if (tables && tables != null && tables.length > 0) {
      tables.forEach((table) => {
        if (table.tableCode === groupField.key) {
          table.tableQuote = true;
          if (
            groupField.fieldArray &&
            groupField.fieldArray.fieldGroup &&
            groupField.fieldArray.fieldGroup.length > 0
          ) {
            if (table.tableFields) {
              table.tableFields.forEach((item: any) => {
                _.get(groupField, "fieldArray.fieldGroup").forEach(
                  (field: any) => {
                    if (item.fieldCode === field.key) {
                      item.fieldQuote = true;
                    }
                  }
                );
              });
            }
          }
        }
      });
    }
  }

  private checkKreFormFieldConfig(code: string, fields: KreFormFieldConfig[]) {
    let result = false;
    if (fields != undefined && fields != null && fields != []) {
      result = fields.some((item: any) => {
        return item.key === code;
      });
    }
    return result;
  }
  private addKreFormFieldConfig(
    tableField: KreTableFieldConfig,
    fields: KreFormFieldConfig[]
  ) {
    let field: KreFormFieldConfig = this.toFormField.getKreFiledFunction(
      tableField
    );
    if (fields == undefined || fields == null) {
      fields = [];
    }
    fields.push(field);
  }
}
